// Action creators for the three transaction families.
//
// Generated from the family table rather than written out three times. Each
// family gets list / detail / byAgent / stats triads, reachable as
// actions.forFamily('payout').listRequest(params).

import * as types from '../../lib/actionTypes.es6';
import { FAMILIES, familyByKey } from './families.es6';

function creator(type) {
  return function create(payload) {
    return { type: type, payload: payload };
  };
}

var OPERATIONS = ['list', 'detail', 'byAgent', 'stats'];

var byFamily = {};

FAMILIES.forEach(function(family) {
  var actions = {};
  OPERATIONS.forEach(function(operation) {
    var triad = family.types[operation];
    actions[operation + 'Request'] = creator(triad.request);
    actions[operation + 'Success'] = creator(triad.success);
    actions[operation + 'Failed'] = creator(triad.failure);
  });
  byFamily[family.key] = actions;
});

// The action set for one family.
export function forFamily(key) {
  return byFamily[familyByKey(key).key];
}

// Named exports for the commission family, since other screens (the agent
// detail page) reference it directly.
export var getCommissionTransactionsRequest =
  byFamily.commission.listRequest;
export var getCommissionTransactionsSuccess =
  byFamily.commission.listSuccess;
export var getCommissionTransactionsFailed =
  byFamily.commission.listFailed;

export var getCommissionTransactionByGuidRequest =
  byFamily.commission.detailRequest;
export var getCommissionTransactionsByAgentRequest =
  byFamily.commission.byAgentRequest;
export var getCommissionTxnStatsRequest = byFamily.commission.statsRequest;

export var getClawbackTransactionsRequest = byFamily.clawback.listRequest;
export var getClawbackTxnStatsRequest = byFamily.clawback.statsRequest;

export var getPayoutTransactionsRequest = byFamily.payout.listRequest;
export var getPayoutTxnStatsRequest = byFamily.payout.statsRequest;

// Calculation log: api/commissions/transaction-requests.
export var getCalculationLogRequest =
  creator(types.GET_COMMISSION_CALCULATION_LOG_REQUEST);
export var getCalculationLogSuccess =
  creator(types.GET_COMMISSION_CALCULATION_LOG_SUCCESS);
export var getCalculationLogFailed =
  creator(types.GET_COMMISSION_CALCULATION_LOG_FAILURE);

export default byFamily;
